module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FeaturedArticles":{"heading":"Vybíráme z odborných článků","linkAllArticles":"Všechny články"}},"de":{"FeaturedArticles":{"heading":"Neuigkeiten im Blog","linkAllArticles":"Mehr aus dem Blog"}},"sk":{"FeaturedArticles":{"heading":"NOVINKY NA BLOGU","linkAllArticles":"Viac z blogu"}}}')
  delete Component.options._Ctor
}
